import { hasPermission } from 'utils/permissions';

export const filterActionMenu = (menuList, authorities) => {
  const filteredList = menuList.filter((item) => !!hasPermission(authorities, item?.permissions));
  return filteredList;
};
